var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation } from "react-router-dom";
import { AppFooter } from "./AppFooter";
import { authContainerStyle, authRootStyle, contentOnlyRootStyle, getContentShellStyle, pageContainerStyle, pageContentStyle, publicShellStyle, } from "./AppShell.styles";
import { PublicHeader } from "./PublicHeader";
import { MenuContainer } from "../menu/Menu.container";
import { RouterManager } from "../router/RouterManager";
import { resolveRouteDefinition } from "../router/routes";
export var AppShell = function () {
    var location = useLocation();
    var currentRoute = resolveRouteDefinition(location.pathname);
    var isAuthLayout = (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.layout) === "auth";
    var isContentOnlyLayout = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.contentOnly;
    var isPublicContentLayout = isContentOnlyLayout && !(currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.allowedRoles);
    var isDesktop = useMediaQuery("(min-width:1024px)");
    if (isAuthLayout) {
        return (_jsx("div", __assign({ style: authRootStyle }, { children: _jsx("div", __assign({ style: authContainerStyle }, { children: _jsx(RouterManager, {}) })) })));
    }
    if (isPublicContentLayout) {
        return (_jsxs("div", __assign({ style: publicShellStyle }, { children: [_jsx(PublicHeader, {}), _jsx(RouterManager, {}), _jsx(AppFooter, { variant: "public" })] })));
    }
    if (isContentOnlyLayout) {
        return (_jsx("div", __assign({ style: contentOnlyRootStyle }, { children: _jsxs("div", __assign({ style: pageContainerStyle }, { children: [_jsx(RouterManager, {}), _jsx(AppFooter, {})] })) })));
    }
    return (_jsx("div", __assign({ style: authRootStyle }, { children: _jsxs("div", __assign({ style: pageContainerStyle }, { children: [_jsxs("div", __assign({ style: getContentShellStyle(isDesktop) }, { children: [isDesktop ? _jsx(MenuContainer, { displayMode: "sidebar" }) : null, _jsxs("main", __assign({ style: pageContentStyle }, { children: [!isDesktop ? _jsx(MenuContainer, { displayMode: "mobile" }) : null, _jsx(RouterManager, {})] }))] })), _jsx(AppFooter, {})] })) })));
};
